<template>
  <div>
    <div class="drafts oa-layout-content">
      <a-table :pagination="false" :columns="columns" :data-source="data">
        <span slot="num" slot-scope="text">{{ text }}台</span>
        <div slot="action">
          <a-button type="link" class="btn-link" @click="add()">
            修改
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" class="btn-link"> 删除 </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination :default-current="1" :total="500" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "lot",
    key: "lot"
  },
  {
    title: "处置部门",
    dataIndex: "name",
    key: "name",
    ellipsis: true
  },
  {
    title: "资产名称",
    dataIndex: "title",
    key: "title"
  },
  {
    title: "规格型号",
    dataIndex: "age",
    key: "age"
    // width: 80,
  },
  {
    title: "数量",
    dataIndex: "num",
    key: "num",
    scopedSlots: { customRender: "num" }
  },
  {
    title: "预算金额(元)",
    dataIndex: "time",
    key: "time"
  },
  {
    key: "operation",
    scopedSlots: { customRender: "action" },
    title: "操作",
    align: "center"
  }
];

const data = [
  {
    key: "1",
    time: 2124343,
    name: "赵丽颖",
    title: "100块钱",
    age: "pdf",
    num: 46,
    lot: 66
  },
  {
    key: "2",
    name: 42,
    time: 42333,
    title: "一张图",
    age: "jpg",
    address: "外星人222",
    num: 16,
    lot: 36
  },
  {
    key: "333",
    name: 4299,
    time: 42333,
    title: "文档",
    age: "txt",
    address: "电竞座椅",
    num: "62",
    lot: 63
  }
];

export default {
  data() {
    return {
      data,
      columns
    };
  },
  methods: {
    add() {
      this.$router.push("/addDisposition");
    },
    pageChange(pageNumber) {
      console.log("Page: ", pageNumber);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/FixedAssets/disDrafts.vue